import { inject, Injectable } from '@angular/core';
import { BoardHelpService } from '../match-tracker/tracker-board/board-help.service';
import { ScoreService } from '../match-tracker/tracker-board/services/score.service';
import { ShotOutcomeEnum } from '../_shared/models/csTypes/enums/shot_outcome';
import { Game } from '../_shared/models/game.model';
import { Match } from '../_shared/models/match.model';
import { Point } from '../_shared/models/point.model';
import { ScoreFormat } from '../_shared/models/score-format.model';
import { AuthService } from '../auth/auth.service';
interface CsvData {
    side1: string;
    side2: string;
    score: string;
    setNumber: number;
    gameNumber: number;
    pointNumber: number;
    gameScoreSide1: number;
    gameScoreSide2: number;
    pointScoreSide1: number;
    pointScoreSide2: number;
    serverSideNumber: number;
    serverPlayerNumber: number;
    returningSide: string;
    returnMade: boolean;
    winningSide: number;
    ace: boolean;
    serveError: boolean;
    doubleFault: boolean;
    winner: boolean;
    forcedError: boolean;
    unforcedError: boolean;
    timestamp?: Date;
}
@Injectable({
    providedIn: 'root'
})
export class StatsService {

    private authService = inject(AuthService);
    private scoreService = inject(ScoreService);
    private bhs = inject(BoardHelpService);

    constructor() { }

    isBreakPoint(point: Point, scoreFormat: ScoreFormat): boolean {
        const serverSideNumber = point?.server?.sideNumber;

        if (serverSideNumber) {
            const returnerSideNumber = serverSideNumber === 1 ? 2 : 1;
            if ((point[`side${returnerSideNumber}Score`] === 3 && point[`side${serverSideNumber}Score`] < 3) ||
                (point[`side${returnerSideNumber}Score`] === 4 && point[`side${serverSideNumber}Score`] === 3) ||
                (!scoreFormat.ads && point[`side${returnerSideNumber}Score`] === 3 && point[`side${serverSideNumber}Score`] === 3)) {
                return true;
            }
        }

        return false;
    }

    isBreakPointConverted(game: Game, scoreFormat: ScoreFormat, sideNumber: number): boolean {
        const secondarySideNumber = sideNumber === 1 ? 2 : 1;
        // Break points converted
        if (game.points.length > 2) {
            const lastPoint = game.points[game.points.length - 1];
            const nextToLastPoint = game.points[game.points.length - 2];

            if (nextToLastPoint.server?.sideNumber === secondarySideNumber && lastPoint.winningSide === sideNumber) {
                if ((nextToLastPoint[`side${sideNumber}Score`] === 3 && nextToLastPoint[`side${secondarySideNumber}Score`] < 3) ||
                    (nextToLastPoint[`side${sideNumber}Score`] === 4 && nextToLastPoint[`side${secondarySideNumber}Score`] === 3) ||
                    (!scoreFormat.ads && nextToLastPoint[`side${sideNumber}Score`] === 3 && nextToLastPoint[`side${secondarySideNumber}Score`] === 3)) {
                    return true;
                }
            }

            return false;
        }
    }

    getCsvData(match: Match) {
        const csvData: CsvData[] = [];
        match.sets.forEach((set, i) => {
            set.games.forEach((game, j) => {
                game.points.forEach((point, k) => {

                    const score = `${this.scoreService.getCurrentScore(match, i, game, point)}`;

                    const data: CsvData = {
                        side1: this.bhs.getPlayersNames(match, 1),
                        side2: this.bhs.getPlayersNames(match, 2),
                        score: score,
                        setNumber: set.setNumber,
                        gameScoreSide1: game.side1Score,
                        gameScoreSide2: game.side2Score,
                        pointScoreSide1: point.side1Score,
                        pointScoreSide2: point.side2Score,
                        gameNumber: j + 1,
                        pointNumber: k + 1,
                        serverSideNumber: point.server?.sideNumber,
                        serverPlayerNumber: point.server?.playerNumber,
                        returningSide: point.server?.returningSide,
                        winningSide: point.winningSide,
                        serveError: point.shots.some(s => s.shotType === 'SE' && s.shotOutcome === 'O' || s.shotOutcome === ShotOutcomeEnum.FOOT_FAULT),
                        returnMade: point.shots.some(s => s.shotDetail === 'RE' && s.shotOutcome === 'I'),
                        ace: point.winReason === 'A',
                        doubleFault: point.winReason === 'DF',
                        winner: point.winReason === 'W',
                        unforcedError: point.winReason === 'U',
                        forcedError: point.winReason === 'F',
                    }

                    if (this.authService.authUserSignal()?.role?.value > 199) {
                        data.timestamp = point.timestamp;
                    }

                    csvData.push(data);
                });
            });
        });

        return csvData;
    }
}
